<template>
    <div class="lawpoint-iconbox text-center" style="cursor: pointer">
        <div class="icon-overlay"></div>
        <div class="icon-detail">
            <div class="icon-front fade-right">
                <img :src="image" alt="NOT FOUND"/>
                <h3>{{title}}</h3>
            </div>
            <!-- hover text -->
            <div class="hover-text">
                <div class="caption-text fade-inleft">
                    <h3>{{innerTitle}}</h3>
                    <p>{{description}}</p>
                    <i class="fa fa-long-arrow-right"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ServiceItem',
        props: {
            image: {
                required: true
            },
            title: {
                required: true
            },
            innerTitle: {
                required: true
            },
            description: {
                required: true
            }
        },
        data () {
            return {};
        },
        methods: {}
    };
</script>
